import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
// import WelcomeOnboard from "./pages/User/WelcomeOnboard";
import OnBoardLayout from "../components/User/MerchantOnboard/OnBoardLayout";
import OnBoardBusiness from "../pages/User/OnBoardBusiness";
import OnBoardInformation from "../pages/User/OnBoardInformation";
import OnBoardSubmitInformation from "../pages/User/OnBoardSubmitInformation";
import FundraiserSubscription from "../pages/User/FundraiserSubscription";
// MembershipActivation removed in new flow
import MembershipConfirmation from "../pages/User/MembershipConfirmation";
import MembershipActivated from "../pages/User/MembershipActivated";
import NewMemberSetup from "../pages/User/NewMemberSetup";
import FundraiserBrand from "../pages/User/FundraiserBrand";
import OrderConfirmation from "../pages/User/OrderConfirmation";
import Subscription from "../pages/User/Subscription";
import ExistingLogin from "../pages/User/ExistingLogin";
import UserForgetPassword from "../pages/User/ForgetPassword";
import UserOTPVerification from "../pages/User/OTPVerification";
import UserResetPassword from "../pages/User/ResetPassword";
import ExistingSubscription from "../pages/User/ExistingSubscription";
import SubscriptionFailure from "../pages/User/SubscriptionFailure";
import GiftCardsPage from "../pages/User/GiftCards";
import GiftCardDetailsComp from "../pages/User/GiftCardDetails";
import GiftCardSelectComp from "../pages/User/GiftCardsSelectComp";
import GiftCardEnterDetailsComp from "../pages/User/GidtCardEnterDetailsComp";
import GiftCardConfirmPayComp from "../pages/User/GiftCardConfirmPayComp";
import GiftCardThankYouComp from "../pages/User/GiftCardThankYouComp";
import GiftCardCancel from "../components/User/common/GiftCardCancel";
import Demosite from '../components/User/DemoSite/index'; 
import UserSubscription from "../components/User/UserSubMobile";
const UserRoutes = () => {
  return (
    <Routes>
      {/* <Route
                path="/welcome-onboard/:verificationCode"
                element={<WelcomeOnboard />}
              /> */}
      <Route
        path="/business-profile"
        element={<OnBoardLayout element={<OnBoardBusiness />} />}
      />
      <Route
        path="/more-information"
        element={<OnBoardLayout element={<OnBoardInformation />} />}
      />
      <Route
        path="/submit-information"
        element={<OnBoardLayout element={<OnBoardSubmitInformation />} />}
      />

      <Route path="/subscription" element={<Subscription />} />
      <Route
        path="/fundraiser-subscription"
        element={<FundraiserSubscription />}
      />
      {/* membership-activation deprecated */}
      <Route path="/member-setup" element={<NewMemberSetup />} />
      <Route
        path="/membership-confirmation"
        element={<MembershipConfirmation />}
      />
      <Route path="/membership-activated" element={<MembershipActivated />} />
      <Route path="/fundraiser-brand/:id" element={<Navigate to="/fundraiser/:id" replace />} />
      <Route path="/success" element={<OrderConfirmation />} />
      <Route path="/existing-login" element={<ExistingLogin />} />
      <Route path="/user-forgetPassword" element={<UserForgetPassword />} />
      <Route path="/user-otpVerification" element={<UserOTPVerification />} />
      <Route path="/user-resetPassword" element={<UserResetPassword />} />
      <Route path="/existing-subscription" element={<ExistingSubscription />} />
      <Route path="/subscription-failed" element={<SubscriptionFailure />} />
      <Route path="/gift-cards" element={<GiftCardsPage />} />
      <Route path="/gift-card/:title/:id" element={<GiftCardDetailsComp />} />
      <Route path="/gift-card/select/:id" element={<GiftCardSelectComp />} />
      <Route path="/gift-card/enter-details/:id" element={<GiftCardEnterDetailsComp />} />
      <Route path="/gift-card/confirm-pay/:id" element={<GiftCardConfirmPayComp />} />
      {/* <Route path="/gift-card/thank-you/:id" element={<GiftCardThankYouComp />} /> */}
      <Route path="/gift-card/thank-you/:sessionId" element={<GiftCardThankYouComp />} />
      <Route path="/cancel" element={<GiftCardCancel />} />
      <Route path='/swoodleherosection' element={<Demosite/>}/>
      <Route path="/usersubscription" element={<UserSubscription/>}/>
      <Route path="*" element={<Navigate to="/member-setup" replace />} />

    </Routes>
  );
};

export default UserRoutes;
